import * as React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { themes } from '@shapeable/theme';
import { merge } from 'lodash';
import { Helmet } from 'react-helmet';
export var ThemeProviderDefaultProps = {
  theme: 'DEFAULT_THEME',
  overrides: {}
}; // -------- Components -------->

export var ThemeProvider = function ThemeProvider(props) {
  var children = props.children,
      overrides = props.overrides,
      statusColor = props.statusColor;
  var themeObj = themes[props.theme] || themes.WEB_THEME;
  var finalThemeObj = merge(themeObj, overrides);
  return React.createElement(StyledComponentsThemeProvider, {
    theme: finalThemeObj
  }, statusColor && React.createElement(Helmet, null, React.createElement("meta", {
    name: "theme-color",
    content: statusColor
  })), children);
};
ThemeProvider.defaultProps = ThemeProviderDefaultProps;